import React from 'react';

const STANDARD_COLORS = [
  '#000000', '#333333', '#666666', '#999999', '#CCCCCC', '#FFFFFF',
  '#FF0000', '#FF9900', '#FFFF00', '#00FF00', '#00FFFF', '#0000FF', '#9900FF', '#FF00FF',
  '#F44336', '#E91E63', '#9C27B0', '#673AB7', '#3F51B5', '#2196F3', '#03A9F4', '#00BCD4',
  '#009688', '#4CAF50', '#8BC34A', '#CDDC39', '#FFEB3B', '#FFC107', '#FF9800', '#FF5722',
];

export default function ColorPicker({
  value,
  onChange,
  recentColors = [],
  label = '',
  style = {},
  name = '',
}) {
  // Gộp recent và standard, loại trùng, recent lên trước
  const palette = [
    ...recentColors.filter(c => !STANDARD_COLORS.includes(c)),
    ...STANDARD_COLORS
  ];

  return (
    <div style={{...style}}>
      {label && <label style={{fontSize: 13, fontWeight: 500, marginBottom: 4, display: 'block'}}>{label}</label>}
      <div style={{
        border: '1.5px solid #e0e0e0',
        borderRadius: 8,
        padding: 12,
        background: '#fafbfc',
        display: 'flex',
        flexDirection: 'column',
        gap: 10,
        minWidth: 220,
        boxShadow: '0 1px 4px #0001'
      }}>
        <div style={{display: 'flex', alignItems: 'center', gap: 12}}>
          <input
            type="color"
            value={value}
            name={name}
            style={{width: 38, height: 38, border: 'none', background: 'none', cursor: 'pointer', boxShadow: '0 1px 2px #0001'}}
            onChange={e => onChange(e.target.value)}
          />
          <span style={{fontSize: 13, color: '#555', marginLeft: 4}}>{value}</span>
        </div>
        {/* Recent colors */}
        {recentColors.length > 0 && (
          <div style={{marginTop: 6}}>
            <div style={{fontSize: 12, color: '#888', marginBottom: 4}}>Gần đây:</div>
            <div style={{display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 8}}>
              {recentColors.map((c, idx) => (
                <span
                  key={c+idx}
                  onClick={() => onChange(c)}
                  style={{
                    display: 'inline-block',
                    width: 24,
                    height: 24,
                    borderRadius: '50%',
                    background: c,
                    border: value === c ? '2.5px solid #222' : '1.5px solid #bbb',
                    cursor: 'pointer',
                    marginRight: 2,
                    boxShadow: value === c ? '0 2px 6px #0002' : undefined,
                    outline: value === c ? '2px solid #2196f3' : undefined,
                    transition: 'border 0.1s, box-shadow 0.1s'
                  }}
                  title={c}
                />
              ))}
            </div>
          </div>
        )}
        {/* Standard palette */}
        <div style={{marginTop: 6}}>
          <div style={{fontSize: 12, color: '#888', marginBottom: 4}}>Màu chuẩn:</div>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(10, 22px)',
            gap: 8,
            justifyContent: 'flex-start',
            paddingBottom: 2
          }}>
            {STANDARD_COLORS.map((c, idx) => (
              <span
                key={c+idx}
                onClick={() => onChange(c)}
                style={{
                  display: 'inline-block',
                  width: 22,
                  height: 22,
                  borderRadius: '50%',
                  background: c,
                  border: value === c ? '2.5px solid #222' : '1.5px solid #bbb',
                  cursor: 'pointer',
                  boxShadow: value === c ? '0 2px 6px #0002' : undefined,
                  outline: value === c ? '2px solid #2196f3' : undefined,
                  transition: 'border 0.1s, box-shadow 0.1s'
                }}
                title={c}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
} 